import _JSXStyle from "styled-jsx/style";
import React from "react";
import { colors } from '@dhis2/ui-constants';
export default {
  styles: /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1795567040"
  }, ["tr.isHoveringExpandedContent.jsx-1795567040>td{background-color:".concat(colors.grey100, ";}"), "tr.isHoveringExpandedContent.jsx-1795567040>th{background-color:".concat(colors.grey300, ";}"), "tr.selected.isHoveringExpandedContent.jsx-1795567040>td{background-color:#cdeae8;}", "tr.expanded.jsx-1795567040>td{border-bottom-color:transparent;}", "tr.expanded.jsx-1795567040>td.bordered{border-bottom-color:".concat(colors.grey300, ";}")]),
  className: "jsx-1795567040"
};